var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "logged" },
    [
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("div", { class: _vm.kaledoMenuClasses }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "top-menu", class: _vm.topMenuClasses },
            [
              _c(
                "div",
                { staticClass: "top-menu-container" },
                [
                  _vm.showKaledoMenu
                    ? _c("top-menu", {
                        attrs: {
                          "company-slug": _vm.config.slug,
                          "has-marketplace": _vm.config.marketplace_client_url
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("layout-navbar"),
              _vm._v(" "),
              _vm.isDesktop && _vm.showCategoryMenu
                ? _c("category-menu")
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("layout-sidebar"),
          _vm._v(" "),
          _c("notifications-sidebar"),
          _vm._v(" "),
          _c("onboarding-modal", {
            attrs: { "is-opened": _vm.showOnboarding },
            on: {
              close: function($event) {
                _vm.showOnboarding = false
              }
            }
          }),
          _vm._v(" "),
          !!_vm.notice.id && _vm.notice.type !== "award"
            ? _c("notice-modal", {
                attrs: { notice: _vm.notice, show: _vm.showNotice },
                on: {
                  close: function($event) {
                    _vm.showNotice = false
                  }
                }
              })
            : !!_vm.notice.id && _vm.notice.type === "award"
            ? _c("award-modal", {
                attrs: {
                  show: _vm.showAward,
                  notice: _vm.notice,
                  "company-slug": _vm.config.slug
                },
                on: {
                  close: function($event) {
                    _vm.showAward = false
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("router-view")
        ],
        1
      ),
      _vm._v(" "),
      _c("layout-footer", {
        attrs: {
          "display-scroll-top": _vm.position < -200,
          config: _vm.config,
          "hide-developed": _vm.hideDeveloped
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c2f773c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c2f773c","hasScoped":false,"transformToRequire":{"img":"src","image":"xlink:href","cimage":"placeholder","c-image":"placeholder","CImage":"placeholder"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Logged.vue
// module id = 2163
// module chunks = 1610